function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8E35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M1 6.333h23.111"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.556 4.556a.807.807 0 0 1-.623-.267.807.807 0 0 1-.266-.622c0-.267.089-.445.266-.623l.09-.088c.088 0 .088-.09.177-.09.089-.088.089-.088.178-.088h.355c.09 0 .09 0 .178.089.089 0 .089.089.178.089l.089.088c.089.09.178.178.178.267.088.089.088.267.088.356 0 .089 0 .266-.088.355 0 .09-.09.178-.178.267a.807.807 0 0 1-.622.267zM7.222 4.556a.807.807 0 0 1-.622-.267.807.807 0 0 1-.267-.622c0-.09 0-.267.09-.356.088-.089.088-.178.177-.267.089-.088.178-.177.267-.177.355-.178.71-.09.977.177.09.09.178.178.178.267.09.089.09.267.09.356a.807.807 0 0 1-.268.622.807.807 0 0 1-.622.267zM9.889 4.556c-.089 0-.267 0-.356-.09-.089-.088-.177-.088-.266-.177-.09-.089-.178-.178-.178-.267C9 3.933 9 3.756 9 3.667c0-.09 0-.267.089-.356.089-.089.089-.178.178-.267a.86.86 0 0 1 1.244 0c.089.09.178.178.178.267.089.089.089.267.089.356 0 .089 0 .266-.09.355-.088.09-.088.178-.177.267a.807.807 0 0 1-.622.267z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FF8E35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M8.111 9.889H17M8.111 24.111H17M9 9.889h0c0 2.755 1.333 5.422 3.556 7.111h0c2.222-1.689 3.555-4.356 3.555-7.111h0M16.111 24.111h0c0-2.755-1.333-5.422-3.555-7.111h0C10.333 18.689 9 21.356 9 24.111h0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.4 20.556h6.933c.978 0 1.778-.8 1.778-1.778v-16c0-.978-.8-1.778-1.778-1.778H2.778C1.8 1 1 1.8 1 2.778v16c0 .978.8 1.778 1.778 1.778H9.71",
  stroke: "#FF8E35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

function SvgWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.0803b162.svg";
export { ForwardRef as ReactComponent };